<template>
  <div class="bg" :style="'background-size: 100% 100%;'">
    <!-- background: url('+ $store.state.config.fileUrl +'icon/pc/big-data-situation-bg.gif);background-size: 100% 100%; -->
    <div class="head">
      <div class="left">
        <div class="sel" :class="{ active: select == 1 }" @click="sel(1)">
          <img
            class="active-img"
            src="@/assets/img/eduBigData/btn-shadow.png"
            alt="选中亮光"
          />
          <img
            class="txt"
            :src="
              select == 1
                ? require('@/assets/img/eduBigData/sel-1-active.png')
                : require('@/assets/img/eduBigData/sel-1.png')
            "
            alt="安全态势"
          />
        </div>
        <div class="sel" :class="{ active: select == 2 }" @click="sel(2)">
          <img
            class="active-img"
            src="@/assets/img/eduBigData/btn-shadow.png"
            alt="选中亮光"
          />
          <img
            class="txt"
            :src="
              select == 2
                ? require('@/assets/img/eduBigData/sel-2-active.png')
                : require('@/assets/img/eduBigData/sel-2.png')
            "
            alt="风险统计"
          />
        </div>
        <div class="sel" :class="{ active: select == 3 }" @click="sel(3)">
          <img
            class="active-img"
            src="@/assets/img/eduBigData/btn-shadow.png"
            alt="选中亮光"
          />
          <img
            class="txt"
            :src="
              select == 3
                ? require('@/assets/img/eduBigData/sel-3-active.png')
                : require('@/assets/img/eduBigData/sel-3.png')
            "
            alt="隐患统计"
          />
        </div>
      </div>
      <div class="name" @click="backHome()">
        <span v-if="name.eduId == 135">三门峡市校园安全双重预防(雪亮工程)平台</span>
        <span v-else-if="name.eduId == 100">焦作市校园安全双重预防(雪亮工程)平台</span>
        
        <span v-else>{{ name.regionName }}校园安全风险防控平台</span>
      </div>
      <div class="right">
        <div class="sel" :class="{ active: select == 4 }" @click="sel(4)">
          <img
            class="active-img"
            src="@/assets/img/eduBigData/btn-shadow.png"
            alt="选中亮光"
          />
          <img
            class="txt"
            :src="
              select == 4
                ? require('@/assets/img/eduBigData/sel-4-active.png')
                : require('@/assets/img/eduBigData/sel-4.png')
            "
            alt="档案统计"
          />
        </div>
        <div class="sel" :class="{ active: select == 5 }" @click="sel(5)">
          <img
            class="active-img"
            src="@/assets/img/eduBigData/btn-shadow.png"
            alt="选中亮光"
          />
          <img
            class="txt"
            :src="
              select == 5
                ? require('@/assets/img/eduBigData/sel-5-1-active.png')
                : require('@/assets/img/eduBigData/sel-5-1.png')
            "
            alt="雪亮工程"
          />
          <!-- <img
            class="txt"
            :src="
              select == 5
                ? require('@/assets/img/eduBigData/sel-5-active.png')
                : require('@/assets/img/eduBigData/sel-5.png')
            "
            alt="雪亮工程"
          /> -->
        </div>
        <div class="sel" :class="{ active: select == 6 }" @click="sel(6)">
          <img
            class="active-img"
            src="@/assets/img/eduBigData/btn-shadow.png"
            alt="选中亮光"
          />
          <img
            class="txt"
            :src="
              select == 6
                ? require('@/assets/img/eduBigData/sel-6-active.png')
                : require('@/assets/img/eduBigData/sel-6.png')
            "
            alt="安全地图"
          />
        </div>
      </div>
    </div>
    <div class="">
      <router-view />
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  props: {},
  data() {
    return {
      name: JSON.parse(sessionStorage.getItem("eduInfo")) || "",
      select: ""
    };
  },
  created() {
    let num = this.$store.state.eduBidDataSelect;
    this.select = num;
    this.sel(num);
  },
  mounted() {},
  computed: {},
  watch: {
    $route: function(val) {
      if (val.name == "eduSecuritySituation_1") {
        this.select = 1;
      }
      this.name = JSON.parse(sessionStorage.getItem("eduInfo"));
    }
  },
  methods: {
    sel(num) {
      this.select = num;
      let path;
      switch (num) {
        case 1:
          path = "/eduSecuritySituation_1";
          break;
        case 2:
          path = "/eduRiskStatistics";
          break;
        case 3:
          path = "/eduHiddenDangerStatistics";
          break;
        case 4:
          path = "/eduFilesStatistics";
          break;
        case 5:
          path = "/eduSafetyCenter";
          break;
        case 6:
          path = "/eduSafetyMap";
          break;
        default:
          break;
      }
      this.$store.commit("setEduBidDataSelect", num);
      this.$Common.pageJump(path, "", 0);
    },
    // 返回首页
    backHome() {
      this.$router.push("/group_basic_info");
    }
  },
  destroyed() {}
};
var targetHeightScale; //存放缩放的比例
var autoResize = {
  resize: function(docWidth, docHeight, targetSelector) {
    var docScale = docHeight / docWidth,
      designWidth = 1920,
      designHeight = 940,
      els = document.querySelectorAll(targetSelector),
      scale = docWidth / designWidth,
      scaleX = docWidth / designWidth,
      scaleY = docHeight / designHeight,
      _this = this;
    (targetHeightScale = scale), //将缩放比例保存，动态计算宽高时需要使用
      this.convertArray(els).forEach(function(el) {
        _this.extend(el.style, {
          width: designWidth + "px",
          height: docScale * designWidth + "px",
          position: "absolute",
          top: 0,
          left: 0,
          transformOrigin: "0 0",
          webkitTransformOrigin: "0 0",
          transform: "scale(" + scale + ")",
          webkitTransform: "scale(" + scale + ")",
          overflow: "hidden",
          webkitOverflowScrolling: "touch"
        });
      });
  },
  convertArray: function(arrayLike) {
    return Array.prototype.slice.call(arrayLike, 0);
  },
  extend: function() {
    var args = Array.prototype.slice.call(arguments, 0);
    return args.reduce(function(prev, now) {
      for (var key in now) {
        if (now.hasOwnProperty && now.hasOwnProperty(key)) {
          prev[key] = now[key];
        }
      }
      return prev;
    });
  },
  scaleResize: function(clientWidth, clientHeight, targetSelector) {
    window.addEventListener(
      "resize",
      this.resize(clientWidth, clientHeight, targetSelector)
    ); //监听窗口的变化
  }
};
var setElementSize = {
  //参数可选，最多选择5个参数。参数按序赋值，如果不需缩放，scale需传入1
  setSize: function(target, scale, target1, target2, target3) {
    var targetScale = scale || 1; //不传scale，不缩放，默认为1
    var targetHeight;
    if (target) {
      targetHeight = innerHeight / targetScale;
    }
    // console.log(targetHeight)
    // if (target1) {
    //     targetHeight = window.height() / targetScale -  document.querySelector(target1).height();
    // }
    // if (target1 && target2 && target3) {
    //     targetHeight = window.height() / targetScale -  document.querySelector(target1).height() -  document.querySelector(target2).height() -  document.querySelector(target3).height();
    // } else if (target1 && target2) {
    //     targetHeight = window.height() / targetScale -  document.querySelector(target1).height() -  document.querySelector(target2).height();
    // } else if (target1) {
    //     targetHeight = window.height() / targetScale -  document.querySelector(target1).height();
    // }
    document.querySelector(".bigdata_page").style.height = targetHeight;

    // var cancas =  document.getElementsByTagName('canvas')
    // var ss = document.getElementsByTagName('canvas')

    // console.log(ss)

    // document.getElementsByTagName('canvas').setAttribute('height','100%')
    // document.getElementsByTagName('canvas').setAttribute('width','100%')
    // console.log(cancas)
    // cancas.width = '100px'
    // cancas.height = '100px'

    // console.log(123)
    // console.log(document.querySelector('.bigdata_page').offsetHeight)
  }
};
var is_fullScreen = false;

window.onresize = function() {
  if (is_fullScreen) {
    changeHeight();
  } else {
    cancelChangeHeight();
  }
  autoResize.scaleResize(innerWidth, innerHeight, ".bigdata_page");
  setElementSize.setSize(".bigdata_page", targetHeightScale);
  // setElementSize.setSize('.left_top', targetHeightScale, '.top')
  // setElementSize.setSize('.map', targetHeightScale, '.top', '.left_bottom');
  // setElementSize.setSize('.right_body', targetHeightScale, '.top');
};
autoResize.scaleResize(innerWidth, innerHeight, ".bigdata_page");
setElementSize.setSize(".bigdata_page", targetHeightScale);
// 全屏状态时更改高度
function changeHeight() {
  is_fullScreen = true;
}

// 取消全屏时恢复
function cancelChangeHeight() {
  is_fullScreen = false;
}
</script>

<style lang="scss" scoped>
.bg {
  width: 100%;
  height: 100%;
  // background: url('~@/assets/img/bg.png');
  background: url("https://school.zzsasoft.com/uploads/icon/pc/big-data-situation-bg.gif")
    center center no-repeat;
  background-size: 100% 100%;
  min-width: 1200px;
  min-height: 768px;
}
.head {
  height: 108px;
  display: flex;
  justify-content: space-around;
  background: url("~@/assets/img/eduBigData/top-line.png") bottom center no-repeat;
  background-size: 100% 50%;
  .left {
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 38%;
  }
  .name {
    display: flex;
    justify-content: space-around;
    align-items: center;
    min-width: 356px;
    text-align: center;
    cursor: pointer;
    position: relative;
    transition: transform 0.3s;
    &:hover {
      transform: scale(1.03);
    }
    span {
      font-size: 24px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #a6e4f9;
      line-height: 37px;
      text-shadow: 0px 2px 4px rgba(255, 161, 161, 0.45);
      background: linear-gradient(180deg, #ffffff 0%, #ffeb9d 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      position: relative;
      bottom: 5px;
    }
  }
  .right {
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 38%;
  }
  .sel {
    display: flex;
    justify-content: space-around;
    align-items: center;
    cursor: pointer;
    width: 121px;
    height: 80px;
    position: relative;
    bottom: 10px;
    &.active {
      .active-img {
        transform: scale(1.2);
        display: block;
        position: absolute;
        top: -5px;
        left: 12px;
      }
    }
    .txt {
      width: 121px;
      height: 30px;
      position: relative;
      transition: transform 0.3s;
      &:hover {
        transform: scale(1.1);
      }
    }
    .active-img {
      display: none;
    }
  }
}
</style>
